export const APP_VERSION = '6.4.2';